import { useState } from 'react';
import ReceiptIssueService from './ReceiptIssueService';

function useReceiptIssue() {
    const [receiptIssues, setReceiptIssues] = useState([]);
    const [total, setTotal] = useState(0);
    const [adminList, setAdminList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const getAdminList = async () => {
        try {
            const response = await ReceiptIssueService.getAdminList();
            // Issues are assigned by username, so only admins linked to a login apply.
            setAdminList(response.data.filter(a => a.user).map(a => ({
                username: a.user.username,
                nickname: a.user.nickname,
            })));
        } catch (err) {
            console.log(err);
        }
    };

    const getIncompleteIssue = async (params) => {
        setIsLoading(true);
        try {
            const response = await ReceiptIssueService.getIncompleteIssue(params);
            setReceiptIssues(response.data.issues);
            setTotal(response.data.total);
            setError(null);
        } catch (err) {
            setError(err);
            console.log(err)
        } finally {
            setIsLoading(false);
        }
    };

    const updateDoneStatus = async (id) => {
      setIsLoading(true);
      try {
        await ReceiptIssueService.updateDoneStatus(id);
        setError(null);
        return true
      } catch (err) {
        setError(err);
        console.log(err)
        return false
      } finally {
        setIsLoading(false);
      }
    };

    return {
        receiptIssues,
        total,
        adminList,
        isLoading,
        error,
        getAdminList,
        getIncompleteIssue,
        updateDoneStatus,
    };
}

export default useReceiptIssue;
